import { GenreNameType } from 'types/games';

export const GENRE_NAME: GenreNameType[] = [
  {
    index: 1,
    tag: '액션',
    englishTag: 'Action',
    imageUrl: 'https://store.steampowered.com/categories/homepageimage/category/action?cc=us&l=english'
  },
  {
    index: 2,
    tag: '어드벤처',
    englishTag: 'Adventure',
    imageUrl: 'https://store.steampowered.com/categories/homepageimage/category/adventure?cc=us&l=english'
  },
  {
    index: 3,

    tag: '전략',
    englishTag: 'Strategy',
    imageUrl: 'https://store.steampowered.com/categories/homepageimage/category/strategy?cc=us&l=english'
  },
  {
    index: 4,

    tag: 'RPG',
    englishTag: 'RPG',
    imageUrl: 'https://store.steampowered.com/categories/homepageimage/category/rpg?cc=us&l=english'
  },
  {
    index: 5,
    tag: '인디',
    englishTag: 'Indie',
    imageUrl: 'https://store.steampowered.com/categories/homepageimage/greatondeck?cc=us&l=english'
  },
  {
    index: 6,
    tag: '캐주얼',
    englishTag: 'Casual',
    imageUrl: 'https://store.steampowered.com/categories/homepageimage/category/casual?cc=us&l=english'
  },
  {
    index: 7,
    tag: '시뮬레이션',
    englishTag: 'Simulation',
    imageUrl: 'https://store.steampowered.com/categories/homepageimage/category/simulation?cc=us&l=english'
  },
  {
    index: 8,
    tag: '레이싱',
    englishTag: 'Racing',
    imageUrl: 'https://store.steampowered.com/categories/homepageimage/category/racing?cc=us&l=english'
  },
  {
    index: 9,
    tag: '스포츠',
    englishTag: 'Sports',
    imageUrl: 'https://store.steampowered.com/categories/homepageimage/category/sports?cc=us&l=english'
  },
  {
    index: 10,
    tag: '디자인',
    englishTag: 'Design & Illustration',
    imageUrl: 'https://store.steampowered.com/categories/homepageimage/vr?cc=us&l=english'
  }
];
